<template>
    <div data-cookie-anchor="">
        <div data-test-id="cookie-banner-component" id="cookie-banner-component">
            <div data-test-id="legacyCookieBanner-component" class="LegacyBanner_c-cookieWarning_3SmlN">
                <div class="LegacyBanner_c-cookieWarning-inner_36s7h">
                    <p>We use cookies to improve your browsing experience. By continuing, you agree to receive cookies on our website. <a data-test-id="cookie-policy-link" :href="isAus" class="c-cookieWarning-link"> Learn more about our cookies policy.</a></p>
                    <button data-test-id="cookieBanner-close-button" aria-label="Close" type="button" class="" @click="closeBanner"><span class="is-visuallyHidden"> Close cookie banner </span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Content from "../data/content";
let lang = process.env.VUE_APP_LOCALITY;

export default {
    mounted() {
      window.addEventListener('load', () => this.removeCookieBanner());
    },
    setup() {
      return {
        isAus: lang == 'au_en' ? 'https://www.menulog.com.au/info/privacy-policy#cookies_policy' : 'https://www.menulog.co.nz/info/privacy-policy#cookies_policy',
      }
    },
    methods: {
        async closeBanner() {
            let banner = document.getElementById('cookie-banner-component');
            document.cookie = 'receive-cookie-deprecation=1'
            banner.remove();
        },
        removeCookieBanner() {
            let consentCookie = this.getCookie('receive-cookie-deprecation');
            if (consentCookie != '') {
                this.closeBanner();
            }
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                "event": "trackPageview",
                "page_name": "Delco Courier Recruitment Landing Page",
                "page_id": "e3502a25-95e1-4e1e-8b7a-c19b3f6855b2",
                "platform_country" : Content[lang].gtm.countryPlatform,
                "platform_environment" : "production",
                "platform_language" :  Content[lang].gtm.platform_language,
                "user_anonymousId" :  "58a7d972-df88-44b0-b2bd-89ea37031ba6",
            });
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }
  };
</script>

<style>
@keyframes LegacyBanner_skeleton-gradient_33RmV {
    0% {
        background-position: 100% 50%
    }

    to {
        background-position: 0 50%
    }
}

.LegacyBanner_c-cookieWarning_3SmlN {
    box-sizing: border-box;
    background-color: #303d3f;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    z-index: 99999990
}

.LegacyBanner_c-cookieWarning-inner_36s7h {
    margin: 0 auto;
    padding: 8px 24px 8px 8px;
    overflow: hidden
}

.LegacyBanner_c-cookieWarning-inner_36s7h p {
    font-size: 12px;
    font-size: .75rem;
    line-height: 1.33;
    color: #fff;
    text-align: center;
    margin: 0 auto
}

.LegacyBanner_c-cookieWarning-inner_36s7h p a {
    color: #fff;
    text-decoration: underline;
}

.LegacyBanner_c-cookieWarning-inner_36s7h button {
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
    display: block;
    position: absolute;
    top: 12px;
    right: 8px;
    width: 10px;
    height: 10px;
    background: url(https://dy3erx8o0a6nh.cloudfront.net/images/icon-close-banner.png) no-repeat 50%;
    background-size: 10px 10px;
    border: none;
    cursor: pointer;
    padding: 1px 6px;
}

.LegacyBanner_c-cookieWarning--is-hidden_2Xnvg {
    display: none
}

.ReopenBannerLink_reopen-link_3VNOh:focus,.ReopenBannerLink_reopen-link_3VNOh:focus-visible {
    box-shadow: 0 0 0 2px #fff;
    outline: none
}

.ReopenBannerLink_reopen-link_3VNOh:focus-visible:after,.ReopenBannerLink_reopen-link_3VNOh:focus:after {
    content: "";
    display: block;
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    box-shadow: 0 0 0 2px #094dac;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px
}

@keyframes ReopenBannerLink_skeleton-gradient_13BRj {
    0% {
        background-position: 100% 50%
    }

    to {
        background-position: 0 50%
    }
}

.ReopenBannerLink_reopen-link_3VNOh {
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    padding: 0 8px 16px
}

.ReopenBannerLink_reopen-link_3VNOh:focus,.ReopenBannerLink_reopen-link_3VNOh:focus-visible {
    position: relative
}

.ReopenBannerLink_reopen-link_3VNOh:focus,.ReopenBannerLink_reopen-link_3VNOh:focus-visible,.ReopenBannerLink_reopen-link_3VNOh:focus-visible:after,.ReopenBannerLink_reopen-link_3VNOh:focus:after {
    bottom: 0;
    left: 0;
    right: 0
}

.ReopenBannerLink_reopen-link--greyBg_3-jIo {
    background-color: #efedea
}

.CookieBanner_c-cookieBanner-title_3TwvI:focus,.CookieBanner_c-cookieBanner-title_3TwvI:focus-visible {
    box-shadow: 0 0 0 2px #fff;
    outline: none;
    position: relative
}

.CookieBanner_c-cookieBanner-title_3TwvI:focus-visible:after,.CookieBanner_c-cookieBanner-title_3TwvI:focus:after {
    content: "";
    display: block;
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    box-shadow: 0 0 0 2px #094dac;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px
}

@keyframes CookieBanner_skeleton-gradient_h8xaJ {
    0% {
        background-position: 100% 50%
    }

    to {
        background-position: 0 50%
    }
}

.CookieBanner_c-cookieBanner-card_2IZ1t {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 376px;
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #f5f3f1;
    box-shadow: 0 -4px 6px 0 rgba(0,0,0,.02),0 -2px 12px -2px rgba(0,0,0,.08),0 -3px 6px 0 rgba(0,0,0,.06);
    z-index: 99999992
}

.CookieBanner_c-cookieBanner-text_2Rleh {
    margin: 0;
    padding: 0
}

.CookieBanner_c-cookieBanner-title_3TwvI {
    font-size: 16px;
    font-size: 1rem;
    line-height: 1.5;
    margin: 4px 0 8px;
    padding: 0;
    color: #242e30;
    text-align: start
}

@media(min-width: 48em) {
    .CookieBanner_c-cookieBanner-title_3TwvI {
        font-size:20px;
        font-size: 1.25rem;
        line-height: 1.4
    }
}

.CookieBanner_c-cookieBanner-title_3TwvI:focus a,.CookieBanner_c-cookieBanner-title_3TwvI:hover a {
    text-decoration: none
}

.CookieBanner_c-cookieBanner-content_1lwJ8 {
    padding: 0 16px;
    text-align: start;
    overflow-y: auto
}

@media(min-width: 48em) {
    .CookieBanner_c-cookieBanner-content_1lwJ8 {
        padding:0 32px
    }
}

@media(max-width: 47.999em) {
    .CookieBanner_c-cookieBanner-content_1lwJ8 {
        background:linear-gradient(rgba(245, 243, 241, 0), #f5f3f1 70%) bottom,radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.3), transparent) bottom;
        background-repeat: no-repeat;
        background-size: 100% 48px,1000% 12px;
        background-attachment: local,scroll
    }
}

.CookieBanner_reopen-link-wrapper_1qoXE {
    position: relative;
    width: 100%
}

@media(max-width: 47.999em) {
    .CookieBanner_c-cookieBanner-ios_dJAvQ {
        padding-bottom:80px
    }
}

.CookieBanner_c-cookieBanner-cta-container_1GAfA {
    padding: 16px 24px 4px
}

.CookieBanner_c-cookieBanner-cta-container_1GAfA .CookieBanner_c-cookieBanner-cta_qMQtV {
    width: 100%
}

@media(min-width: 48em) {
    .CookieBanner_c-cookieBanner-cta-container_1GAfA .CookieBanner_c-cookieBanner-cta_qMQtV {
        width:inherit;
        margin-left: 16px;
        margin-bottom: 0
    }
}

.CookieBanner_c-cookieBanner-cta-container_1GAfA .CookieBanner_c-cookieBanner-cta_qMQtV:not(:last-child) {
    margin-bottom: 16px
}

@media(min-width: 48em) {
    .CookieBanner_c-cookieBanner-cta-container_1GAfA .CookieBanner_c-cookieBanner-cta_qMQtV:not(:last-child) {
        margin-bottom:0
    }
}

@media(min-width: 48em) {
    .CookieBanner_c-cookieBanner-cta-container_1GAfA {
        display:flex;
        flex-direction: row-reverse;
        padding: 16px;
        margin: 0 16px;
        min-width: 320px
    }
}

.is-visuallyHidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}
</style>